import Icon from '@vfz/ui/dist/components/icon/icon';
import { SupportCaseComment } from 'api/support-case.types';
import { ZDeviceIcon } from 'assets/icons/ZDeviceIcon';
import { Col } from 'components/Grid';
import React from 'react';
import { ContentUtil } from 'utils';
import { DateFormat, dateUtils } from 'utils/date';

import content from '../../support-case-detail.content';
import * as S from './support-case-comments.styles';

interface ISupportCaseCommentsArguments {
  comments: SupportCaseComment[];
}
const contentUtil = new ContentUtil({ content, componentName: 'SupportCaseComments' });

const ZIGGO_CUSTOMER_SERVICE_NAME = ' '; // NOTE: Yes, this is actually a single space =)

const SupportCaseComments = ({ comments }: ISupportCaseCommentsArguments) => {
  function isCustomerService(author: string) {
    return author.toLowerCase() === ZIGGO_CUSTOMER_SERVICE_NAME;
  }

  function getAuthorIcon(author: string) {
    if (isCustomerService(author)) {
      return <ZDeviceIcon />; // TODO: FIND REPLACEMENT
    }

    return <Icon name="user" />;
  }
  return (
    <>
      {comments.map((comment, index) => (
        <S.Comment data-testid="support-case-comment" key={`support-case-comment-${index}`}>
          <S.Info m={4} data-testid="support-case-comment-info">
            <S.Spacer />
            <S.Author>
              {getAuthorIcon(comment.author)}{' '}
              {isCustomerService(comment.author)
                ? contentUtil.translateToString('customerService.name')
                : comment.author}
            </S.Author>
            <S.Date>{dateUtils.format(comment.creationDate, DateFormat.FULL_DATE)}</S.Date>
            <S.Spacer />
          </S.Info>
          <Col m={8} data-testid="support-case-comment-message">
            <S.Message>{comment.message}</S.Message>
          </Col>
        </S.Comment>
      ))}
    </>
  );
};

export default SupportCaseComments;
